var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.listNews.length > 0
    ? _c("div", [
        _c("section", { staticClass: "container-fluid py-0" }, [
          _vm.title
            ? _c(
                "div",
                {
                  staticClass: "d-flex align-items-center",
                  class: _vm.classTitle,
                },
                [
                  _c("h2", { staticClass: "content-title" }, [
                    _vm._v(_vm._s(_vm.title)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "view-more" },
                    [
                      _vm.viewMore
                        ? _c(
                            "router-link",
                            {
                              staticClass: "nav-link border-link",
                              attrs: { to: { name: "portal.news.archive" } },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.textMore) +
                                  "\n                "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]
              )
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "container-fluid news news--slider" },
          [
            _c(
              "slider-control",
              _vm._l(_vm.listNews, function (news, index) {
                return _c(
                  "slide-element",
                  { key: index },
                  [_c("news-card", { attrs: { news: news } })],
                  1
                )
              }),
              1
            ),
          ],
          1
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }